// extracted by mini-css-extract-plugin
module.exports = {"header":"NewBroadcastContentHeader_header__1KtJp","message":"NewBroadcastContentHeader_message__3OVJZ","action":"NewBroadcastContentHeader_action__pkuZe"};